import React from 'react';
import Logo from '../../assets/logo.png'
import Fb from '../../assets/fb.png'
import Insta from '../../assets/insta.png'
import Twitter from '../../assets/twitter.png'

import './footer.style.css';

const footer = () => {
    return (
        <div id='footer' className=" footer-container">
            <p>Powered by <strong>RailYatri</strong></p>

            <br></br>
            <a href="https://www.facebook.com/ryfoodontrain/" className="footer-img"><img src={Fb} alt="dfr"></img></a>
            <a href="https://www.instagram.com/foodontrain/" className="footer-img"><img src={Insta} alt="dfr"></img></a>
            <a href="https://twitter.com/ryfoodontrain" className="footer-img"><img src={Twitter} alt="dfr"></img></a>


        </div>
    )
}

export default footer;